class VideoSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = null;
    this.delayedInit = this.dataset.delayedInit === 'true';
    this.sliderEl = this.querySelector('.glide');
  }

  connectedCallback() {
    if (this.delayedInit) {
      const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            console.log('init video')
            this.init();
            this.observer.unobserve(this);
          }
        });
      };

      this.observer = new IntersectionObserver(handleIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      });
      this.observer.observe(this);
      return
    }

    this.init();
  }

  init () {
    this.slider = new Glide(this.sliderEl, {
      type: 'carousel',
      startAt: 0,
      perView: 3,
      focusAt: 0,
      gap: 44,
      peek: 650,
      breakpoints: {
        3100: {
          perView: 3,
          peek: 350,
          gap: 44,
          focusAt: 0,
        },
        2045: {
          perView: 2,
          peek: 450,
          gap: 44,
          focusAt: 0,
        },
        1724: {
          perView: 2,
          peek: 300,
          gap: 44,
          focusAt: 0,
        },
        1455: {
          perView: 1,
          peek: 550,
          gap: 44,
          focusAt: 0,
        },
        1371: {
          perView: 1,
          peek: 500,
          gap: 44,
          focusAt: 0,
        },
        1250: {
          perView: 1,
          peek: 450,
          gap: 44,
          focusAt: 0,
        },
        1157: {
          perView: 1,
          peek: 400,
          gap: 44,
          focusAt: 0,
        },
        1030: {
          perView: 1,
          peek: 300,
          gap: 44,
          focusAt: 0,
        },
        850: {
          perView: 1,
          peek: 250,
          gap: 44,
          focusAt: 0,
        },
        748: {
          perView: 2,
          peek: 75,
          gap: 44,
          focusAt: 0,
        },
        550: {
          perView: 1,
          peek: 100,
          gap: 34,
          focusAt: 0,
        },
        415: {
          perView: 1,
          peek: 80,
          gap: 22,
          focusAt: 0,
        }
      }
    });

    this.slider.on('mount.after', () => {
      this.playVideos();
      this.updateBullets();
    });
    this.slider.on('run.after', () => {
      this.playVideos();
      this.updateBullets();
    });

    this.slider = this.slider.mount();
  }

  updateBullets () {
    this.querySelectorAll('.glide__bullet')
      .forEach(el => el.classList.remove('glide__bullet--active'));

    this.querySelector(`.glide__bullet[data-glide-dir="=${this.slider.index}"]`).classList.add('glide__bullet--active')
  }

  playVideos () {
    this.querySelectorAll('.glide__slide')
      .forEach(el => {
        const video = el.querySelector('video')
        video.pause();
        video.currentTime = 0;
      });

    const activeVideo = this.querySelector('.glide__slide--active video');

    if (!activeVideo.classList.contains('loaded')) {
      activeVideo.querySelectorAll('source')
        .forEach(source => {
          if (source.src === null || source.src === '') source.src = source.dataset.src;
        });
      activeVideo.load();
      activeVideo.classList.add('loaded');
    }

    activeVideo.play();
  }
}

customElements.define('video-slider', VideoSlider);